import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { SWRConfig } from 'swr';
import './index.css';
import App from './App.tsx';
import { swrGlobalConfig } from '@/lib/swr-global-config';
import { TenantProvider } from '@/providers/tenant-provider';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_APP_VERSION,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById('root')!).render(
  <SWRConfig value={swrGlobalConfig}>
    <TenantProvider>
      <App />
    </TenantProvider>
  </SWRConfig>
);
